module.exports = __webpack_public_path__ + "static/img/17069D_1_C_20210222_fit.cb7d437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17069D_1_C_20210222_fit.png
// module id = lS+A
// module chunks = 0